import { reactive } from 'vue';

export const criarEpProcEtapa = () => {
    return reactive({
        id: 0,
        idepproc: 0,
        ordem: 0,
        cdetapa: '',
        nmetapa: '',
        descricao: '',
        ckinicial: 'N',
        ckfinal: 'N',
        idetapa_avanco1: 0,
        idetapa_avanco2: 0,
        idetapa_retorno1: 0,
        idetapa_retorno2: 0,
        pzdias: 0,
        ativo: 'S',
        idlogin: 0,
    })
}
